let csrfToken;

export async function getCsrfToken() {
  if (csrfToken) return csrfToken;
  const res = await fetch('/api/csrf', { credentials: 'same-origin' });
  if (!res.ok) {
    throw new Error('Failed to fetch CSRF token');
  }
  const { csrfToken: token } = await res.json();
  csrfToken = token;
  return token;
}

export async function prefetchCsrfToken() {
  try {
    await getCsrfToken();
  } catch (e) {
    // noop: fetching lazily on first use will still work
  }
}
